// Bars fixed along the bottom (the player, a listening room) report their height here so the
// app shell can leave room for them instead of covering the composer.
import { computed, onBeforeUnmount, reactive, watch, type WatchSource } from 'vue'

const heights = reactive(new Map<string, number>())

/** Space to keep clear at the bottom of the page, in px. */
export const bottomInset = computed(() => Math.max(0, ...heights.values()))

/** Report the bar's height under `key` while `el` is set. */
export function useBottomBar(key: string, el: WatchSource<HTMLElement | null>): void {
  const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(([e]) => heights.set(key, e!.borderBoxSize[0]!.blockSize))
  watch(el, (now, old) => {
    if (old) ro?.unobserve(old)
    if (now) ro?.observe(now)
    else heights.delete(key)
  })
  onBeforeUnmount(() => {
    ro?.disconnect()
    heights.delete(key)
  })
}
